export const getContactEmailTemplate = (firstName, lastName, email, phone, tier, message) => {
  return `
    <!DOCTYPE html>
    <html>
    <head>
      <style>
        body { font-family: Arial, sans-serif; line-height: 1.6; color: #333; }
        .container { max-width: 600px; margin: 0 auto; padding: 20px; }
        .header { background-color: #1c293a; color: white; padding: 20px; text-align: center; }
        .content { background-color: #f9f9f9; padding: 20px; border: 1px solid #ddd; }
        .field { margin-bottom: 15px; }
        .field strong { color: #1c293a; }
        .message-box { background-color: white; padding: 15px; border-left: 4px solid #1c293a; margin-top: 10px; }
        .footer { text-align: center; margin-top: 20px; color: #666; font-size: 14px; }
      </style>
    </head>
    <body>
      <div class="container">
        <div class="header">
          <h2>New Contact Form Submission</h2>
        </div>
        <div class="content">
          <p>A new contact form has been submitted through the Walkspan website.</p>
          
          <div class="field">
            <strong>Name:</strong> ${firstName} ${lastName}
          </div>
          
          <div class="field">
            <strong>Email:</strong> ${email}
          </div>
          
          <div class="field">
            <strong>Phone:</strong> ${phone}
          </div>
          
          ${tier ? `<div class="field">
            <strong>Plan Tier:</strong> ${tier}
          </div>` : ''}
          
          <div class="field">
            <strong>Message:</strong>
            <div class="message-box">
              ${message.replace(/\n/g, '<br>')}
            </div>
          </div>
        </div>
        
        <div class="footer">
          <p>Best regards,<br>Walkspan Contact Form System</p>
        </div>
      </div>
    </body>
    </html>
  `;
};
